import React from "react";
import dynamic from 'next/dynamic'
const Carousel = dynamic(() => import('react-multi-carousel'), { 
  ssr: false 
})
import Image from "next/image";
import RightArrowBottom from "./RightArrowBottom";
import LeftArrowBottom from "./LeftArrowBottom";
import { urlForImage } from '~/lib/sanity.image'
import "react-multi-carousel/lib/styles.css";


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 4 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 3  // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 375 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const prefix = '/timber/'

const SliderTimber = ({timbers}) => {
  return (
    <div className="parent">
        
      <Carousel
        responsive={responsive}
        autoPlay={false}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={true}
        partialVisible={false}
        customLeftArrow={<LeftArrowBottom/>}
        customRightArrow={<RightArrowBottom />} 
        containerClass="spacer-carousel-container"
        dotListClass="spacer-custom-dot-list-style"
      >
        {timbers.length ? (
          timbers.map((timber) => {
            return (
              <div className="slider"  key={timber._id}>
                <a href={prefix + timber.slug.current}>
                <div className="imageWrapper">
                  {timber.smallImage ? (
                    <Image
                      key={timber._id}
                      src={urlForImage(timber.smallImage).url()}
                      alt={timber.title ? timber.title : "slider"}
                      width={0}
                      height={0}
                      sizes="100vw"
                      style={{ width: '100%', height: 'auto' }} 
                    />
                  ) : (
                    <>null</>
                  )}
                </div>
                <h3 className="text-2xl font-semibold text-primary mt-10 mb-5">{timber.title}</h3>
                </a>
              </div>
            );
          })
        ) : (
          <></>
        )} 
      </Carousel>
    </div>
  );
};
export default SliderTimber;
